enum FeatureFlags {
    ENTITIES_OVERVIEW_LINK_ENABLED = 'entities-overview-link-enabled',
    TELEMETRY_EXPORTER_CLASSIC_UI_SIDE_NAV_LINK_ENABLED = 'telemetry-exporter-classic-ui-side-nav-link-enabled',
    TRACES_OVERVIEW_CLASSIC_UI_SIDE_NAV_LINK_ENABLED = 'traces-overview-classic-ui-side-nav-link-enabled',
    API_ANALYTICS_BUILT_IN_DASHBOARD_DISABLED = 'api-analytics-built-in-dashboard-disabled',
    BUILT_IN_DASHBOARDS_SKIP_LOADING_RESOURCES_ENABLED = 'built-in-dashboards-skip-loading-resources-enabled',
    DEFER_LABELS_CALL_IN_LANDING_PAGE_ENABLED = 'defer-labels-call-in-landing-page-enabled',
    MONITORING_CENTER_MPKI_CERTS_EXPIRY_BANNER_ENABLED = 'monitoring-center-mpki-certs-expiry-banner-enabled',
    ALERTS_BASIC_ADVANCED_FILTER_ENABLED = 'alerts-basic-advanced-filter-enabled',
    ALERTS_TYPE_FILTER_BANNER_ENABLED = 'alerts-type-filter-banner-enabled',
    HIDE_INCORRECT_CHARTS_IN_BUILT_IN_DASHBOARDS_ENABLED = 'hide-incorrect-charts-in-built-in-dashboards-enabled',
    OSD_LOG_SEARCH_PAGE_MODE = 'osd-log-search-page-mode',
    MC_KIBANA_LOG_SEARCH_ENABLED = 'mc-kibana-log-search-enabled',
    CLASSIC_BUILT_IN_DASHBOARDS_PAGE_DISABLED = 'classic-monitoring-page-disabled',
    CLASSIC_CUSTOM_DASHBOARDS_PAGE_DISABLED = 'classic-custom-dashboards-page-disabled',
    CLASSIC_REPORTS_PAGE_DISABLED = 'classic-reports-page-disabled',
    CLASSIC_RAW_DATA_PAGE_DISABLED = 'classic-raw-data-page-disabled',
    CLASSIC_SETTINGS_PAGE_DISABLED = 'classic-settings-page-disabled',
    CLASSIC_TOOLS_PAGE_DISABLED = 'classic-tools-page-disabled',
    CLASSIC_LOGPOINTS_PAGE_DISABLED = 'classic-logpoints-page-disabled',
    BUILT_IN_DASHBOARD_90_DAY_WINDOW_ENABLED = 'built-in-dashboard-90-day-window-enabled',
}

export default FeatureFlags;